const pmeta = {
  "pmeta.min": "min.",
  "pmeta.anes_local": "Anestesia locale",
  "pmeta.anes_general": "Anestesia generale",
  "pmeta.anes_none": "Nessuna",
  "pmeta.sessions_1": "1 appuntamento",
  "pmeta.sessions_2": "2 appuntamenti",
  "pmeta.sessions_1_2": "1–2 appuntamenti",
  "pmeta.sessions_2_3": "2–3 appuntamenti",
  "pmeta.sessions_ongoing": "In corso",
};

export default pmeta;
